<div
    class="container-fluid"
    data-test-automation="tenure-subject-land">
    <div class="row">
        <div class="col-xs-6">
            <label class="control-label required-input">Subject land type</label>
            <div [hidden]="!(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)">
                <ng-select
                    class="nlr-ng-select"
                    [searchable]="false"
                    [clearable]="false"
                    [ngClass]="{'has-error': subjectLandType | formFieldHasError}"
                    [disabled]="readonly ||(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                    [name]="'subjectLandType'+name"
                    [id]="'subjectLandType'+name"
                    placeholder="Select a subject land type"
                    [items]="internalSubjectLandTypeLookups"
                    bindLabel="description"
                    #subjectLandType="ngModel"
                    [ngModel]="tenure.subjectLandType"
                    (change)="subjectLandTypeOptionChange($event)"
                    required>
                </ng-select>
            </div>
        </div>
        <div class="col-xs-6">
            <div [hidden]="!showSubjectLandDescription()">
                <label
                    class="control-label"
                    [ngClass]="{'required-input': subjectLandDescriptionIsRequired()}">
                    {{label}}
                </label>
                <div
                    class="input-group"
                    [ngClass]="{'has-error': subjectLandDescriptionArea | formFieldHasError}">
                    <span class="input-group-addon corner">
                        <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                    </span>
                    <textarea
                        class="form-control"
                        [id]="'subjectLandDescription'+name"
                        [name]="'subjectLandDescription'+name"
                        placeholder="Enter subject land description"
                        #subjectLandDescriptionArea="ngModel"
                        rows="2"
                        cols="60"
                        maxlength="{{subjectLandDescriptionMaxLength}}"
                        [(ngModel)]="tenure.subjectLandDescription"
                        [required]="subjectLandDescriptionIsRequired()"
                        data-test-automation="tenure-subject-land-description"></textarea>
                </div>
                <p>
                    <span>{{getSubjectLandDescriptionCharactersRemaining()}}</span>
                    <span>characters remaining</span>
                </p>
            </div>
            @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                <div>
                    @if (showTitle()) {
                        <div>
                            <label
                                class="control-label"
                                [ngClass]="{'required-input': titleIsRequired()}">
                                {{titleReferenceLabel}}
                            </label>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': titleText | formFieldHasError}">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit"></i>
                                </span>
                                <input
                                    type="text"
                                    class="form-control"
                                    [name]="'title'+name"
                                    [id]="'title'+name"
                                    #titleText="ngModel"
                                    [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                    placeholder="Enter title"
                                    [(ngModel)]="tenure.title"
                                    [nlrPattern]="titlePattern"
                                    [required]="titleIsRequired()" />
                            </div>
                            @if ((titleText | formFieldHasError) && titleText.errors) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Title is invalid, e.g. format should be CL123-1963, EC1234, 1-1, 2-2A</span>
                                </div>
                            }
                            @if (titleText.invalid && isTitleDuplicated()) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Title reference duplicated</span>
                                </div>
                            }
                            @if (titleVerifyError()) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>{{titleVerifyError()}}</span>
                                </div>
                            }
                        </div>
                    }
                    @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                        <div>
                            @if (tenure.title && !titleVerified()) {
                                <input
                                    type="checkbox"
                                    [id]="'titleVerified'+name"
                                    [name]="'titleVerified'+name"
                                    class="hidden"
                                    [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                                    [ngModel]="titleVerified()"
                                    [required]="true" />
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
    <span class="verify-status">
        @if (tenure.title && titleVerified() && !(subjectLandDescriptionArea | formFieldHasError)  && !(subjectLandType | formFieldHasError)) {
            <i class="nlrp-icon nlrp-icon-verified-passed active"></i>
        }
        @if (titleVerifyError() || (subjectLandDescriptionArea | formFieldHasError) || (subjectLandType | formFieldHasError)) {
            <i class="nlrp-icon nlrp-icon-error error"></i>
        }
    </span>
</div>
